import React from "react";
import FormCurrency from "./FormCurrency";
import { Typography } from "@mui/material";

const UpdateCurrency = ({ handleClose, currency }) => {
  return (
    <div>
      <Typography variant="h4" sx={{ textAlign: "center", mb: 4 }}>
        Update Currency
      </Typography>
      <FormCurrency handleClose={handleClose} currency={currency} />
    </div>
  );
};

export default UpdateCurrency;
